export enum DateFormat {
  DATE_SHORT = 'DATE_SHORT', // 10/14/1983
  DATE_MED = 'DATE_MED', // Oct 14, 1983
  DATE_MED_WITH_WEEKDAY = 'DATE_MED_WITH_WEEKDAY', // Fri, Oct 14, 1983
  DATE_FULL = 'DATE_FULL', // October 14, 1983
  DATE_HUGE = 'DATE_HUGE', // Friday, October 14, 1983
  OFFSET = 'OFFSET', // Date (UTC+07:00)
  OFFSET_AND_ABB = 'OFFSET_AND_ABB', // Date (UTC+07:00 GMT+7)
}
